import { render, staticRenderFns } from "./AppContact.vue?vue&type=template&id=d964be06&scoped=true&"
import script from "./AppContact.vue?vue&type=script&lang=js&"
export * from "./AppContact.vue?vue&type=script&lang=js&"
import style0 from "./AppContact.vue?vue&type=style&index=0&id=d964be06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d964be06",
  null
  
)

component.options.__file = "AppContact.vue"
export default component.exports